import React, { createContext } from 'react';
import { useGetCustomGroups, useGetCustomRanges } from '../../api/report/report';
import { CustomGroup, CustomRange } from '../../model';

export interface IReturnDetailsValues {
    customGroups: CustomGroup[] | undefined;
    customRanges: CustomRange[] | undefined;
}

export const ReturnDetailsContext = createContext<IReturnDetailsValues | null>(null);

export function ReturnDetailsContextProvider(props: { value?: IReturnDetailsValues; children?: React.ReactNode }) {
    const { data: customGroups } = useGetCustomGroups();
    const { data: customRanges } = useGetCustomRanges();

    return (
        <ReturnDetailsContext.Provider
            value={
                props.value ?? {
                    customGroups,
                    customRanges,
                }
            }
        >
            {props.children}
        </ReturnDetailsContext.Provider>
    );
}
